type LogLevel = 'log' | 'info' | 'warn' | 'error' | 'debug'

type LogEntry = {
  time: string
  level: LogLevel
  message: string
}

const MAX_ENTRIES = 200
// 1件あたりの巨大オブジェクト出力でファイルが肥大化しないよう、メッセージ長を制限する
const MAX_MESSAGE_LENGTH = 2000
const buffer: LogEntry[] = []
let installed = false

const truncate = (message: string): string =>
  message.length > MAX_MESSAGE_LENGTH ? `${message.slice(0, MAX_MESSAGE_LENGTH)}...(以下省略)` : message

const serializeArg = (arg: unknown): string => {
  if (typeof arg === 'string') {
    return arg
  }
  if (arg instanceof Error) {
    return `${arg.name}: ${arg.message}\n${arg.stack ?? ''}`
  }
  try {
    return JSON.stringify(arg)
  } catch {
    return String(arg)
  }
}

// console出力をリングバッファに記録し、エラー情報ファイルにFE側のログを含められるようにする
export const installConsoleLogCapture = (): void => {
  if (installed) {
    return
  }
  installed = true

  const levels: LogLevel[] = ['log', 'info', 'warn', 'error', 'debug']
  levels.forEach(level => {
    // eslint-disable-next-line no-console
    const original = console[level].bind(console)
    // eslint-disable-next-line no-console
    console[level] = (...args: unknown[]): void => {
      try {
        buffer.push({
          time: new Date().toISOString(),
          level,
          message: truncate(args.map(serializeArg).join(' ')),
        })
        if (buffer.length > MAX_ENTRIES) {
          buffer.splice(0, buffer.length - MAX_ENTRIES)
        }
      } catch {
        // ログ収集自体の失敗で本来の出力を妨げないようにする
      }
      original(...args)
    }
  })
}

export const getConsoleLogs = (): string => {
  if (buffer.length === 0) {
    return '(コンソールログはありません)'
  }
  return buffer.map(entry => `[${entry.time}] [${entry.level.toUpperCase()}] ${entry.message}`).join('\n')
}
